export default __webpack_public_path__ + "static/media/sick.e2f1110f.png";